module.exports = __webpack_public_path__ + "static/img/MAG1.718f8be1.jpg";